module.exports = __webpack_public_path__ + "static/img/12.65a7b04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/12.jpg
// module id = E23z
// module chunks = 1